import { Vuetable } from 'vuetable-2';
import Vue from 'vue';
import { ProgressButton } from './progress-button/progress-button';
import Toolbar from './toolbar/toolbar';
import UnsavedChangesModalComponent from './unsaved-changes-modal/unsaved-changes-modal';
import ActionNotificationsComponent from './action-notifications/action-notifications.vue';
import RowsComponent from './rows/rows.vue';
import GlobalErrorsComponent from './global-errors/global-errors.vue';
import TopNavigation from './top-navigation/top-navigation';
import CheckboxListComponent from './checkbox-list/checkbox-list';
import MailWizzSelectorComponent from './mail-wizz-selector/mail-wizz-selector';
import ReadMoreComponent from './read-more/read-more';

Vue.component('vuetable', Vuetable);
Vue.component('top-navigation', TopNavigation);
Vue.component('progress-button', ProgressButton);
Vue.component('toolbar', Toolbar);
Vue.component('unsaved-changes-modal', UnsavedChangesModalComponent);
Vue.component('action-notifications', ActionNotificationsComponent);
Vue.component('rows', RowsComponent);
Vue.component('global-errors', GlobalErrorsComponent);
Vue.component('checkbox-list', CheckboxListComponent);
Vue.component('mail-wizz-selector', MailWizzSelectorComponent);
Vue.component('read-more', ReadMoreComponent);
